import Highcharts from 'highcharts';

export const figure70 = {
chart: {
	       backgroundColor: 'rgba(255, 255, 255, 0.0)',
type: 'column',

},
title: {
text: ''
},
exporting: {
enabled: false
},
credits: {
enabled: false
},
xAxis: {
	       categories: ['شمال أفريقيا وغرب آسيا', 'أفريقيا جنوب الصحراء', 'أوقيانوسيا', 'أمريكا اللاتينية ومنطقة البحر الكاريبي', 'شرق آسيا وجنوب شرق آسيا', 'أوروبا وأمريكا الشمالية', 'العالم'],
// tickInterval: 5,

// tickmarkPlacement: 'on',
// tickPositions: [0, 5, 10, 15, 19]
labels: {
style: {
	       textOverflow: 'none',
	       crosshair: true,	       
  }
},
crosshair: true
},
yAxis: {
title: {
text: ''
       }, labels: {
formatter: function () {
	 return this.value + '';
 }
},
min: 0,
max: 500000,
tickInterval: 100000,
labels: {
	       format: '{value:,.0f}',
	       style: {
			       fontWeight: 'normal',
			       color: '#999999',
			       fontSize: '12px'
		       },
       },
       },
tooltip: {
// pointFormat: 'Series {series.name} <b>{point.y:.4f}</b>'
formatter: function () {
var y_value = (this.y / 1).toFixed(0);
return this.x+'<br/>' + this.series.name + '' + ': <b>' + y_value + '' + '</b>';
},
},
legend: {
	       enabled: false,
       }, 
plotOptions: {
column: {
pointPadding: 0,
borderWidth: 0
},
series: {
marker: {
       enabled: false,
       "symbol": 'circle',
// radius: 2
}
}
},
//colors: ['#77A612', '#66A6B7', '#00122F', 'yellow', 'pink', 'purple', '#77A612', '#66A6B7'],
series: [{
name: '2010',
color: '#e2f0d9',
data: [20.27, 7346.52, 11584.14, 13808.16, 8434.98, 302196.1, 343428.2]
}, {
name: '2015',
color: '#a9d18e',
data: [2359, 6348, 12033, 14500, 17427, 344039, 397541]
}, {
	name: '2022',
	      color: '#70ad47',
	      data: [5494, 9796, 21172, 21154, 18650, 367186, 444054, ]

       }


]
};